/** Represents chart types. */
export var ChartType;
(function (ChartType) {
    ChartType[ChartType["Column"] = 3] = "Column";
    ChartType[ChartType["Histogram"] = 4] = "Histogram";
    ChartType[ChartType["Bar"] = 5] = "Bar";
    ChartType[ChartType["Combo"] = 6] = "Combo";
    ChartType[ChartType["Area"] = 7] = "Area";
    ChartType[ChartType["Line"] = 9] = "Line";
    ChartType[ChartType["Pie"] = 10] = "Pie";
    ChartType[ChartType["Polar"] = 11] = "Polar";
    ChartType[ChartType["Doughnut"] = 12] = "Doughnut";
    ChartType[ChartType["Radar"] = 13] = "Radar";
    ChartType[ChartType["SteppedLine"] = 14] = "SteppedLine";
})(ChartType || (ChartType = {}));
//# sourceMappingURL=chart_type.js.map